<template>
    <div>
        <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <BlockUI v-if="busy">
        <div class="loader"></div>
        </BlockUI>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-12 col-md-12 col-xl-8 mb-3" v-if="(statusVerify == '-3' || statusVerify == 'null')">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                            <h3 class="mb-0">ข้อมูลยืนยันตัวตน SHOP</h3>
                            </div>
                        </div>
                        </div>
                        <template>
                            <formVerify
                                :submitForm.sync="submitForm"
                                :data="data" 
                                :account="account"
                                :images="images"
                                :tabKey.sync="tabKey"
                                typeFormTab="commission"
                                ref="registerCommisstion"
                            />
                        </template>
                    </card>
                </div>
                <div :class="['col-12 col-md-12', (statusVerify == '-3' || statusVerify == 'null') ? 'col-xl-4' : 'col-xl-12']">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <card shadow type="secondary">
                                <div slot="header" class="bg-white border-0">
                                <div class="row align-items-center">
                                    <div class="col-12">
                                    <h3 class="mb-0">ยืนยันตัวตน</h3>
                                    </div>
                                </div>
                                </div>
                                <div class="row p-3 mt-1 text-center">
                                    <div :class="[(statusVerify == '-3' || statusVerify == 'null') ? 'col-4':'col-6' ,'pb-2 text-right']">
                                        <h3 class="mb-0">สถานะ:</h3>
                                    </div>
                                    <div :class="[(statusVerify == '-3' || statusVerify == 'null') ? 'col-8':'col-6' , 'pb-2 text-left']">
                                        <b-badge :variant="statusCommission( statusVerify ).color +' report'" >
                                            {{ statusCommission( statusVerify ).status }}
                                        </b-badge>
                                    </div>
                                    <template v-if="statusVerify == '-3'">
                                        <div class="col-4 pb-4 text-right">
                                        <h3 class="mb-0">เหตุผล:</h3>
                                        </div>
                                        <div class="col-8 pb-4 text-left">
                                            <h4>{{remarkVerify}}</h4>
                                        </div>
                                    </template>
                                    <div class="col-6 pb-2">
                                        <button class="btn btn-info btn-block btn-icon py-2 mb-2" @click="showComfirmModal()" v-if="(statusVerify == '-3' || statusVerify == 'null')">
                                            {{ (statusVerify == ' null' ? 'ยืนยันตัวตน' : 'อัพเดทข้อมูล') }}
                                        </button>
                                    </div>
                                    <div class="col-6 pb-2">
                                        <button class="btn btn-secondary btn-block btn-icon py-2 mb-2" @click="reset()" v-if="(statusVerify == '-3' || statusVerify == 'null')">
                                        คืนค่า
                                        </button>
                                    </div>
                                    <div class="col-12" v-if="statusVerify == '-3'">
                                        <h4 class="text-muted">หากคุณไม่ยืนยันตัวตน จะไม่ได้รับค่าคอมมิชชัน ของรายการพัสดุที่เก็บเงินปลายทาง</h4>
                                    </div>
                                    <div class="col-12" v-else-if="statusVerify == '0'">
                                        <h4 class="text-muted">กรุณารอพนักงานตรวจสอบข้อมูล 1-3 วันทำการ</h4>
                                    </div>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import validatePop from "@/plugins/validatePop.js"
import formVerify from '@/components/custom/brance/FormVerify'
import { statusCommission } from "../plugins/statusCommission.js"
import Compressor from 'compressorjs'
const API_URL = process.env.VUE_APP_API;
export default {
    name: "Registercommission",
    components: {
        formVerify
    },
    data() {
        return {
            busy: false,
            statusVerify: null,
            remarkVerify: null,
            idShop: 0,
            submitForm: false,
            tabKey:'person',
            data:{
                name_title: "",
                tax_id: "",
                laser_code: "",
                date_birthday: "",
                date_expiry: "",
                email: "",
                name: "",
                address: "",
                state: "",
                district: "",
                province: "",
                postcode: "",
                tel: "",
                errorTax: false,
            },
            account: [{
                account_id: '',
                account_name: '',
                account_branch: '',
                account_bank: '',
                branch_code: '',
            }],
            images:[
                {
                    name:'image_card_front',
                    lable:'รูปภาพบัตรประชาชนด้านหน้า',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_card_back',
                    lable:'รูปภาพบัตรประชาชนด้านหลัง',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_card',
                    lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
                    file:null,
                    preview:"", 
                },
                {
                    name:'image_account',
                    lable:'รูปภาพสมุดบัญชี',
                    file:null,
                    preview:"",
                },
            ],
            statusCommission: statusCommission,
        }
    },
    mounted(){
        this.getDataShop()
    },
    methods:{
        getDataShop() {
            this.busy = true
            this.$http
                .get(API_URL + "/shop/shop/" + this.idShop, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
                })
                .then(res => {
                let checkError = validatePop(res);
                if (!checkError.status) {
                    this.handleLoader()
                    if (checkError.notices == "token is expired") {
                    this.$router.push("/logout");
                    }
                    this.showErrorModal(checkError.msg);
                    return false;
                }
                let results = res.data.data[0];
                this.statusVerify = String(results.status_resgister);
                this.remarkVerify = results.status_remark;
                this.handleLoader()
            });
        },
        registerCommission(){
            this.submitForm = true
            this.$refs.registerCommisstion.$v.$touch();
            if (this.$refs.registerCommisstion.$v.$invalid) {
                return false
            }
            if(this.account[0].branch_code.length == 3){
                this.account[0].branch_code = "0"+this.account[0].branch_code
            }
            this.busy = true
            this.$http
                .post(
                    API_URL + "/shop/register/commission",
                    {
                        email: this.data.email,
                        laser_code: this.data.laser_code,
                        card_id: this.data.tax_id,
                        tel: this.data.tel,
                        account: this.account,
                        date_birthday: this.data.date_birthday,
                        card_expire: this.data.date_expiry,
                        name_title: this.data.name_title.nameTitle,
                        name: this.data.name,
                        address: this.data.address,
                        state: this.data.state,
                        district: this.data.district,
                        province: this.data.province,
                        postcode: this.data.postcode,
                        customer_type: this.$refs.registerCommisstion.tabKey,
                        ...( ( this.$refs.registerCommisstion.tabKey == 'person' ) ? { 
                            images: JSON.stringify({
                                image_card_front: this.images[0].preview ,
                                image_card_back: this.images[1].preview,
                                image_card: this.images[2].preview,
                                image_account: this.images[3].preview
                            }),
                        } : {
                            images: JSON.stringify({
                                image_company_certificate: this.images[0].preview ,
                                image_certified_of_vat: this.images[1].preview,
                                image_business_account: this.images[2].preview,
                            }),
                        } ),
                        
                        type: this.$refs.registerCommisstion.tabKey
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let checkError = validatePop( res )
                    if( !checkError.status ){
                        this.handleLoader();
                        this.showErrorModal( checkError.msg )
                        return false
                    }
                    this.statusVerify = String(res.data.data.status);
                    this.handleLoader()
                    this.modalSuccess("สมัครสมาชิกสำเร็จ")
                })
                .catch(error => { 
                });
        },
        handleLoader(){
            this.busy = !this.busy
        },
        reset(){
            Object.keys(this.data).forEach(key => {
                this.data[key] = ""
            });
            this.account = [{
                account_id: '',
                account_name: '',
                account_branch: '',
                account_bank: '',
                branch_code: '',
            }];
            this.images.forEach(( item , index ) => {
                this.images[index].file = null;
                this.images[index].preview = "";
            });
            this.submitForm = false
        },
        uploadImage(index,e) {
            if (e.target.files.length < 1) return false;
            const image = e.target.files[0]
            let SELF = this
            new Compressor(image, {
              quality: 0.6,
              maxHeight: 1024,
              maxHeight: 1024,
                success(result) {
                  const reader = new FileReader();
                  reader.readAsDataURL(result)
                  reader.onload = e => {
                    SELF.$set(SELF.images[index], 'preview' , e.target.result)
                  }
                }
            })
        },
        showComfirmModal() {
            this.$bvModal
                .msgBoxConfirm(`กรุณาตรวจสอบข้อมูลลูกค้าให้ถูกต้อง หลังจากยืนยันแล้วข้อมูลลูกค้าจะไม่สามารถแก้ไขได้`, {
                    title: "กรุณายืนยัน",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.registerCommission();
                    }
                });
        },
        modalSuccess(msgBody) {
            this.$bvModal
                .msgBoxOk(msgBody, {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.reset()
                    }
                });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    }
}
</script>
<style lang="scss">
  .report{
    color: #212529;
    font-size: 1.1rem;
    width: 100%;
  }
</style>